module.exports = __webpack_public_path__ + "static/media/Step 9-Starting_Weapon.a702f2d4.png";